import { render } from "./InstructorCard.vue?vue&type=template&id=031af642&scoped=true"
import script from "./InstructorCard.vue?vue&type=script&lang=js"
export * from "./InstructorCard.vue?vue&type=script&lang=js"

import "./InstructorCard.vue?vue&type=style&index=0&id=031af642&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031af642"]])

export default __exports__